const background = require('../assets/images/background.jpg')
const logo = require('../assets/images/RELogo.png')
const logo_crop = require('../assets/images/RELogo_crop.png')

export {logo,logo_crop, background}